<template>
  <div>
    <div class="row bg-grey pt-3">
      <div class="col-12">
        <h3 class="title-h3 border-bottom pb-3">
          <button type="button" class="btn btn-back" @click="$router.push('/movers')" />
          Back
        </h3>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-6 l-m-b-20">
        <h1>Pending Invitations</h1>
      </div>
      <div class="col-6 text-right">
        <button v-if="$_can('carriers.movers.invite')"
                class="btn btn-primary ld-ext-right"
                @click="reinviteMovers"
                :class="loadingButton ? 'running' : ''"
                :disabled="buttonDisabled"
        >
          RESEND INVITATIONS
          <div class="ld ld-ball ld-flip" />
        </button>
        <button v-if="$_can('carriers.movers.delete-invitations')"
                class="btn btn-delete ld-ext-right"
                @click="deleteInvitations"
                :disabled="buttonDisabled"
                :class="loadingButtonDelete ? 'running' : ''"
        >
          DELETE INVITATIONS
          <div class="ld ld-ball ld-flip" />
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 l-m-b-20">
        <div class="input-group search">
          <button type="button" class="btn input-group-btn" @click="clearSearch">
            <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
          </button>
          <input class="form-control" type="text" v-model="q" @keyup="searchText($event)" placeholder="Search" />
        </div>
      </div>
      <div class="col-11 filters-field">
        <span v-if="filters.carrier !== '' || filters.company !== ''">Filters:</span>
        <span v-if="filters.carrier" class="filter-item btn btn-filter">
          <span class="mod-icon-filter" @click="removeFilter('carrier')" />
          Carrier: {{ carriers.find(el => el.id === filters.carrier).name }}</span>
        <span v-if="filters.company" class="filter-item btn btn-filter">
          <span class="mod-icon-filter" @click="removeFilter('company')" />
          Company: {{ companies.find(el => el.id === filters.company).name }}</span>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="btn btn-secondary add-filter" @click="showFilters = true" />
      </div>
    </div>
    <template v-if="!movers">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <table class="table m-table table-hover l-m-t-20">
        <thead class="m-table__heading">
          <tr>
            <th class="m-table__id">ID</th>
            <th @click="sortBy('email')" :class="{ active: filters.sortKey === 'email' }"
                class="sortable"
            >
              Email
              <span class="arrow" :class="filters.sortOrders['email'] ? 'dsc' : 'asc'" />
            </th>
            <th @click="sortBy('carriers.name')" :class="{ active: filters.sortKey === 'carriers.name' }"
                class="sortable"
            >
              Carrier
              <span class="arrow" :class="filters.sortOrders['email'] ? 'dsc' : 'asc'" />
            </th>
            <th @click="sortBy('companies.name')" :class="{ active: filters.sortKey === 'companies.name' }"
                class="sortable"
            >
              Company
              <span class="arrow" :class="filters.sortOrders['companies.name'] ? 'dsc' : 'asc'" />
            </th>
            <th @click="sortBy('updated_at')" :class="{ active: filters.sortKey === 'updated_at' }"
                class="sortable"
            >
              Invitation Date
              <span class="arrow" :class="filters.sortOrders['updated_at'] ? 'dsc' : 'asc'" />
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="(mover, index) in movers" :key="mover.id">
            <td>{{ mover.id }}</td>
            <td>{{ mover.email }}</td>
            <td>{{ mover.carrier }}</td>
            <td>{{ mover.company }}</td>
            <td>{{ mover.invitation_date }}</td>
            <td class="py-0 align-baseline">
              <div class="check-field">
                <label :for="index" :class="{'check-open' : emailsResend.find((el) => el.id === mover.id)}">
                  <span class="checkmark" />
                  <input type="checkbox" v-model="emailsResend" :value="mover" :id="index" class="btn-check" />
                </label>
              </div>
            </td>
          </tr>
          <tr v-if="!movers.length">
            <td colspan="8" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Carrier</label>
                      <simple-select v-model="filters.carrier"
                                     :options="carriers"
                                     placeholder="Select Carrier"
                                     @input="filter"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Company</label>
                      <simple-select v-model="filters.company"
                                     :options="companies"
                                     placeholder="Select Company"
                                     @input="filter"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="!(!filters.carrier && !filters.company && !filters.status && !filters.foreman &&
                        filters.foreman !== 0 && !filters.ssn && filters.ssn !== 0)"
              >
                Clear filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import toastr from 'toastr';
import Errors from '../../classes/Errors';
import PhoneMask from '../../classes/PhoneMask';

export default {
  name: 'Movers',
  data() {
    return {
      filters: {
        carrier: '',
        company: '',
        sortKey: '',
        sortOrders: [],
      },
      movers: null,
      dataToSend: {
        company_id: null,
        carrier_id: null,
        emails: [''],
      },
      emailsResend: [],
      buttonDisabled: false,
      loadingButton: false,
      loadingButtonDelete: false,
      q: '',
      showFilters: false,
      phoneMask: new PhoneMask(),
      errors: new Errors(),
    };
  },
  computed: {
    ...mapState({
      carriers: state => state.carriers.carriers.data,
      companies: state => state.companies.companies.data,
    }),
  },
  created() {
    this.getInvitations();
  },
  methods: {
    reinviteMovers() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      this.emailsResend.forEach(invitee => {
        const data = [];
        data.emails = [];
        data.company_id = invitee.company_id;
        data.carrier_id = invitee.carrier_id;
        data.emails[0] = invitee.email;
        axios
          .post(`movers/invite`, { ...data })
          .then(() => {
            toastr.success('Successfully sent invitation');
            this.dataToSend = {
              company_id: null,
              emails: [''],
            };
            this.emailsResend = [];
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
          })
          .finally(() => {
            this.loadingButton = false;
            this.buttonDisabled = false;
          });
      });
    },
    deleteInvitations() {
      this.buttonDisabled = true;
      this.loadingButtonDelete = true;
      const ids = [];
      this.emailsResend.forEach(invitee => {
        ids.push(invitee.id);
      });
      axios
        .delete(`movers/invite`, {
          data: {
            ids,
          },
        })
        .then(() => {
          toastr.success('Invitation(s) deleted.');
          this.dataToSend = {
            company_id: null,
            emails: [''],
          };
          this.emailsResend = [];
          this.getInvitationsFiltered();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButtonDelete = false;
          this.buttonDisabled = false;
        });
    },
    getInvitations() {
      axios
        .get(`movers/pending-invitations`)
        .then(res => {
          this.movers = res.data.data;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    getInvitationsFiltered() {
      axios
        .get(
          `movers/pending-invitations?q=${this.q}&company_id=${
            this.filters.company
          }&default_carrier_id=${this.filters.carrier}&sort=${this.filters.sortKey}&order=${
            this.filters.sortOrders[this.filters.sortKey] ? 'asc' : 'desc'
          }`,
        )
        .then(res => {
          this.movers = res.data.data;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    searchText(e) {
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.getInvitationsFiltered();
        }, 500);
      }
    },
    clearSearch() {
      this.q = '';
      this.getInvitationsFiltered();
    },
    filter() {
      this.getInvitationsFiltered();
    },
    clearFilters() {
      this.filters = Object.assign(
        {
          carrier: '',
          company: '',
          sortKey: '',
          sortOrders: [],
        },
        {},
      );
      this.filter();
      this.showFilters = false;
    },
    sortBy(key) {
      this.$set(this.filters, 'sortKey', key);
      this.$set(this.filters.sortOrders, key, !this.filters.sortOrders[key]);
      this.getInvitationsFiltered();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/movers/MoversPending.vue